import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PRODUCTS, STATUS, todayStr, monthStartStr } from "@/lib/constants";

export function useFilterOptions(withAgents) {
  const [merchants, setMerchants] = useState([]);
  const [agents, setAgents] = useState([]);
  useEffect(() => {
    api.get("/merchants").then((r) => setMerchants(r.data)).catch(() => {});
    if (withAgents) api.get("/users").then((r) => setAgents(r.data.filter((u) => u.role === "agent"))).catch(() => {});
  }, [withAgents]);
  return { merchants, agents };
}

export function FilterBar({ value, onChange, showAgents = false, showStatus = false, showSearch = false }) {
  const { merchants, agents } = useFilterOptions(showAgents);
  const set = (k, v) => onChange({ ...value, [k]: v });
  const preset = (p) => {
    if (p === "today") onChange({ ...value, from: todayStr(), to: todayStr(), preset: p });
    else if (p === "mtd") onChange({ ...value, from: monthStartStr(), to: todayStr(), preset: p });
    else onChange({ ...value, from: "", to: "", preset: "all" });
  };
  const presetBtn = (p, label) => (
    <button key={p} type="button" data-testid={`filter-preset-${p}`} onClick={() => preset(p)}
      className={`px-3 h-9 text-xs font-semibold rounded-md border transition-colors ${value.preset === p ? "bg-indigo-600 border-indigo-500 text-white" : "border-slate-700 text-slate-400 hover:text-slate-100"}`}>{label}</button>
  );
  return (
    <div className="panel p-3 flex flex-wrap items-center gap-2 mb-5" data-testid="filter-bar">
      {showSearch && <input data-testid="filter-search" className="field w-56" placeholder="Search ref, traveler, PNR…" value={value.q || ""} onChange={(e) => set("q", e.target.value)} />}
      <div className="flex gap-1">{presetBtn("today", "Today")}{presetBtn("mtd", "MTD")}{presetBtn("all", "All time")}</div>
      <input data-testid="filter-from" type="date" className="field w-40" value={value.from || ""} onChange={(e) => onChange({ ...value, from: e.target.value, preset: "custom" })} />
      <span className="text-slate-600 text-xs">to</span>
      <input data-testid="filter-to" type="date" className="field w-40" value={value.to || ""} onChange={(e) => onChange({ ...value, to: e.target.value, preset: "custom" })} />
      <select data-testid="filter-product" className="field w-44" value={value.product || ""} onChange={(e) => set("product", e.target.value)}>
        <option value="">All products</option>{PRODUCTS.map((p) => <option key={p}>{p}</option>)}
      </select>
      <select data-testid="filter-merchant" className="field w-44" value={value.merchant_id || ""} onChange={(e) => set("merchant_id", e.target.value)}>
        <option value="">All merchants</option>{merchants.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
      </select>
      {showAgents && (
        <select data-testid="filter-agent" className="field w-44" value={value.agent_id || ""} onChange={(e) => set("agent_id", e.target.value)}>
          <option value="">All agents</option>{agents.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
      )}
      {showStatus && (
        <select data-testid="filter-status" className="field w-40" value={value.status || ""} onChange={(e) => set("status", e.target.value)}>
          <option value="">All statuses</option>{Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      )}
    </div>
  );
}

export function filterParams(f) {
  const p = {};
  ["q", "from", "to", "product", "merchant_id", "agent_id", "status"].forEach((k) => { if (f[k]) p[k] = f[k]; });
  return p;
}
